import React, { FC } from 'react'
import './MedicalDetails.scss'
import emptyAvarter from "./../../../../../Assets/images/user-empty-avatar.png";
import Table from 'react-bootstrap/esm/Table';

interface propsType {
    value: any;
    disable: boolean;
}

const MedicalDetails:FC<propsType> = ({ value, disable }) => {
  const {
    workflow,
    lastname,
    firstname,
    nin,
    photo
  } = value

  const uploadPic = (e:any) => {
    // console.log(e)
  }

  // console.log("VAL VAL", value)
  return (
    <div className="aptitude-details my-5">

          <div className="container-fluid">
            <div className="row d-flex justify-content-center">
              <div className="col-md-9 offset-md">
                <div className="card bg-white p-2">
                  <div className="table-responsive">
                  <Table bordered>
                    <tbody>
                      <tr>
                      <td colSpan={2} className="p-0">
                        <div className="card-header text-center text-dark bg-white p-1">
                          <div className="row">
                            <div className="col-2">
                               <img src={"logo.png"} alt="police" className="cbp-logo"/>
                            </div>
                            <div className="col-10 pr-5">
                              <h2 className="text-blue font-weight-bolder aptitude-title">Nigeria Police Force</h2>
                              <h5 className="text-dark">Department of Training and Development</h5>
                              <h5 className="text-success">Medical Screening Exercise Slip</h5>
                            </div>
                          </div>
                        </div>
                      </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <div className="d-flex justify-content-center align-item-center">
                            <div className="aptitude-profile-photo-content">
                            {photo
                              ? (<img src={`data:image/png;base64, ${photo}`} alt="" className="w-100 aptitude-profile-photo"/>)
                              : (<img src={emptyAvarter} alt="" className="w-100 aptitude-profile-photo" onClick={(e) => uploadPic(e)}/>)
                            }
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                          <td className="text-right">Status:</td>
                          <td className="text-success font-bold font-weight-bold">{workflow.medical.initialized === 1 ? "Qualified" : "Not qualified"}</td>
                        </tr>
                      {workflow.medical.initialized && (
                          <>
                          <tr>
                            <td className="text-right w-50">Applicant Name:</td>
                            <td className="font-weight-bold  w-50">{lastname + " " + firstname} </td>
                          </tr>
                          <tr>
                          <td className="text-right  w-50">Candidate No (NIN) :</td>
                          <td className="font-weight-bold  w-50">{nin} </td>
                        </tr>
                        <tr>
                          <td className="text-right  w-50">Date:</td>
                          <td className="font-weight-bold  w-50">{workflow.medical.medicalDate} </td>
                        </tr>

                        <tr>
                          <td className="text-right  w-50">Time:</td>
                          <td className="font-weight-bold w-50">{workflow.medical.medicalTime}</td>
                        </tr>
                          <tr>
                          <td className="text-right w-50">Venue:</td>
                          <td className="font-weight-bold w-50">{workflow.medical.medicalVenue}</td>
                        </tr></>
                      )}

                    </tbody>
                  </Table>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className="text-center text-black cpb-note">
            <div> NOTE: Concerned Candidates are therefore advised to attend the exercise as scheduled above with the following documents.</div>
                <li>Letter of invitation </li>
                <li>NIN slip</li>
                <li>Dress code: White T-Shirt on white short</li>
             <div> No admission into the center without full compliance with the above.</div>
        </div>
    </div>
  )
}

export default MedicalDetails
